import { MutationTree } from 'vuex';
import { SuiviFacturesModuleState } from '.';
import { SUIVI_FACTURES } from './mutation-types';
import { initialState as resetStateAvantEcheance } from './modules/SuiviFacturesAvantEcheance/state';
import { initialState as resetStateEnRetard } from './modules/SuiviFacturesEnRetard/state';
import { initialState as resetStateSuiviFinancier } from './modules/SuiviFinancier/state';
import { initialState as resetStatePayees } from './modules/SuiviFacturesPayees/state';


export const mutations: MutationTree<SuiviFacturesModuleState> = {
    [SUIVI_FACTURES.CLEAR_ALL](state) {
        Object.assign(state.suiviFacturesAvantEcheanceState, resetStateAvantEcheance);
        Object.assign(state.suiviFacturesEnRetardState, resetStateEnRetard);
        Object.assign(state.suiviFinancierState, resetStateSuiviFinancier);
        Object.assign(state.suiviFacturesPayeesState, resetStatePayees);
    },
};
